/* global Cesium */
import { setViewMode } from './View'
import getDefaultImageLayer from './getDefaultImageLayer'

/**
 * 初始化cesium服务
 * @param {JSON} params 地图参数
 * @param {String} params.id 地图div 参数
 * @param {JSON} params.imageLayer 地图初始化 底图参数
 * @param {Boolean} [params.imageLayerisSkyBoxShow] 是否透明sky
 * @param {Boolean} [params.viewMode] 初始化模式 2D 3D 2.5D
 * @param {Number[]} [params.center]  初始化中心点 [116.0,39.0]
 * @param {Number[]} [params.height]  初始化视角高度 10103520
 * @returns viewer
 */
function initMap (params) {
  // 与 openlayer 不同 cesium 以 viewer 基础控件
  const id = params.id || 'cesiumContainer'
  const defaultImageLayer = getDefaultImageLayer(params)
  const viewer = new Cesium.Viewer(id, {
    // 默认离线模式
    imageryProvider: defaultImageLayer,
    // 不显示图层选择控件
    baseLayerPicker: false,
    // 是否创建动画小器件，左下角仪表
    animation: false,
    // 是否显示geocoder小器件，右上角查询按钮
    geocoder: false,
    // 是否显示右上角的帮助按钮
    navigationHelpButton: false,
    // 是否显示时间轴
    timeline: false,
    // 是否显示点击要素之后显示的信息
    infoBox: false,
    // 是否显示全屏按钮
    fullscreenButton: false,
    // 是否显示Home按钮
    homeButton: false,
    // 是否显示3D/2D选择器
    sceneModePicker: true,
    // 是否显示选取指示器组件
    selectionIndicator: false,
    // 大气效果 false 球体白边
    skyAtmosphere: false,

    // lixia 20210604 背景透明 && 2285 && 2286
    orderIndependentTranslucency: false,
    contextOptions: {
      webgl: {
        alpha: true
      }
    }
  })
  // 全局变量
  this.viewer = viewer

  // 版权设置
  viewer._cesiumWidget._creditContainer.style.display = 'none'

  // 设置大气效果为 false
  viewer.scene.globe.showGroundAtmosphere = false

  viewer.scene.globe.baseColor = Cesium.Color.BLACK
  viewer.sceneModePicker.viewModel.duration = 0.0

  if (params.isSkyBoxShow) {
    // lixia 20210604 设置背景透明
    viewer.scene.skyBox.show = false
    viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)
  }

  if (params.enableZoom) {
    // lixia 20210608 设置是否可滚轮缩放
    // 如果为真，允许用户放大和缩小。如果为假，相机将锁定到距离椭圆体的当前距离
    viewer.scene.screenSpaceCameraController.enableZoom = false
  }
  // BING KEY 配置 已经修改为从配置获取
  setDefaultBingKey(params)
  // 设置 初始化 显示模式
  setDefaultViewMode(params, this)
  setDefaultPosition(params.viewParam, viewer)
  // lixia 20210604 摄像机视口远近参数，可设置地球大小
  // viewer.Camera.DEFAULT_VIEW_FACTOR = 1.0
  if (params.isNavigation === true) {
    setDefaultNavigation(viewer)
  }
  //  加载完成函数
  setLoadStatusEvent(viewer)

  return viewer
}

function setLoadStatusEvent (viewer) {
  var helper = new Cesium.EventHelper()
  helper.add(viewer.scene.globe.tileLoadProgressEvent, function (e) {
    // TODO
    //  console.log('加载地图切片进入此回调', e)
    if (e === 0) {
      // console.log('加载完成', e)
    }
  })
}

function setDefaultNavigation (viewer) {
  const optinis = []
  optinis.defaultResetView = Cesium.Rectangle.fromDegrees(70, 80, 130, -25)   //minlon西 minlat南 maxlon东 maxlat北
  // 罗盘
  optinis.enableCompass = true
  // 缩放
  optinis.enableZoomControls = true
  // 比例尺
  optinis.enableDistanceLegend = false
  // 指南针外环
  optinis.enableCompassOuterRing = true
  if (Cesium.viewerCesiumNavigationMixin) {
    viewer.extend(Cesium.viewerCesiumNavigationMixin, optinis)
  }
}

function setDefaultViewMode (params, self, CB) {
  const viewMode = params.viewMode || '3D'
  if (viewMode === '2D' || viewMode === '2.5D') {
    setViewMode(viewMode, CB, self)
    // TODO 重设位置bug
    // self.viewer.camera.setView({
    //   destination: Cesium.Cartesian3.fromDegrees(16.39, 39.9, 850000)
    // })
  }
}

function setDefaultPosition (params, viewer) {
  // 默认 中心点
  const center = params.center || []
  const lon = center[0] || 116.1
  const lat = center[1] || 39.1
  const height = params.height || 20000000.0
  // 设置默认位置
  viewer.camera.setView({
    destination: Cesium.Cartesian3.fromDegrees(lon, lat, height),
    // orientation: {
    //   heading: Cesium.Math.toRadians(0),
    //   pitch: Cesium.Math.toRadians(-90),
    //   roll: Cesium.Math.toRadians(0)
    // }
  })
  return true
}

function setDefaultBingKey (params) {
  const bingKey = params.bingKey || 'SHHFsraTruJW1WlBZo4W~Voo0XWCy1Zt2-2iAVLxvFQ~Ai_3AucRsH-FTKgfBT34iPCl128DNCGslmWLM0Hplg9UgMZoftwZFkKbhHu_RAo8'
  if (bingKey) {
    // Cesium.BingMapsApi.defaultKey = bingKey
  }
}

function getMap () {
  if (this.viewer) {
    return this.viewer
  }
  return null
}

export { initMap, getMap }
